// Formatowanie daty
export const formatDate = (dateString: string) => {
  const date = new Date(dateString)
  return date.toLocaleDateString('pl-PL', {
    hour: '2-digit',
    minute: '2-digit'
  })
}

// Formatowanie rozmiaru pliku
export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 B'

  const k = 1024
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))

  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
}

// Ikona dla odpowiedniego typu pliku
export const getFileIcon = (fileType: string): string => {
  if (fileType.includes('image')) return 'fa-file-image'
  if (fileType.includes('pdf')) return 'fa-file-pdf'
  if (fileType.includes('word') || fileType.includes('document')) return 'fa-file-word'
  if (fileType.includes('excel') || fileType.includes('sheet')) return 'fa-file-excel'
  if (fileType.includes('zip') || fileType.includes('rar')) return 'fa-file-archive'
  return 'fa-file'
}
